import type { NotifyPort } from '@/features/messages/domain/notify'
import type { TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const approveTimeOffDept = async (
	port: TimeOffPort,
	id: string,
	actorId: string,
	actorName: string,
	note: string | null,
	notify: NotifyPort,
): Promise<TimeOffRequest> => {
	try {
		const request = await port.approveDept(id, actorId, actorName, note)
		notify.success('hr.requestApprovedByDepartment')
		return request
	} catch {
		notify.error('hr.requestApproveFailed')
		throw new Error('Failed to approve request.')
	}
}

export { approveTimeOffDept }
